var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrosimeBlat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f90b45df-e524-41f9-ae1a-e239697fc58a",
    "data-name": "Layer 52",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ae50f77d-aa71-4503-b783-805c3b4edc9e,.f2d37e90-6505-4177-96d8-f270d41dea90{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.ae50f77d-aa71-4503-b783-805c3b4edc9e{stroke-width:10px;}.f2d37e90-6505-4177-96d8-f270d41dea90{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grosime_blat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eee66015-6bac-4e47-b5ee-ad16fa096263",
    "data-name": "grosime_panou copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f15a9003-5840-4de5-8aa1-3c1a14e58d28",
    "data-name": "sticla_2 copy 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ae50f77d-aa71-4503-b783-805c3b4edc9e",
    x: 5,
    y: 77,
    width: 190,
    height: 45
  })), /*#__PURE__*/React.createElement("g", {
    id: "b93b8ccc-a7ed-4fa6-93b2-c8543af9e10b",
    "data-name": "Arrow copy 6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f2d37e90-6505-4177-96d8-f270d41dea90",
    x1: 100,
    y1: 196.5,
    x2: 100,
    y2: 131.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,156.13a1.75,1.75,0,0,1-2.42-.54L100,133,85.62,155.59a1.75,1.75,0,0,1-2.42.54,1.77,1.77,0,0,1-.54-2.42l15.86-24.9a1.76,1.76,0,0,1,3,0l15.86,24.9a1.79,1.79,0,0,1,.27.94A1.77,1.77,0,0,1,116.8,156.13Z",
    transform: "translate(0 -0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f2d37e90-6505-4177-96d8-f270d41dea90",
    x1: 100,
    y1: 2.5,
    x2: 100,
    y2: 67.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2,43.87a1.75,1.75,0,0,1,2.42.54L100,67l14.38-22.58a1.75,1.75,0,0,1,2.42-.54,1.77,1.77,0,0,1,.54,2.42l-15.86,24.9a1.76,1.76,0,0,1-3,0L82.66,46.29a1.79,1.79,0,0,1-.27-.94A1.77,1.77,0,0,1,83.2,43.87Z",
    transform: "translate(0 -0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrosimeBlat);
export default __webpack_public_path__ + "static/media/grosime_blat.772ad2f4f6bfe0b1363fa4b037a21e3b.svg";
export { ForwardRef as ReactComponent };